import { isInTeams } from "common/teams";

export function getStorage() {
  return isInTeams() ? window.localStorage : window.sessionStorage;
}
